<template>
    <div class="home-container">
      <div class="d-flex flex-column align-items-center justify-content-center gap-3">
        <h5 class="extra-large-text">დაამატეთ რეგიონი</h5>
        <form class="add-form modal-form-grid-wrapper p-4 border-radius-10" @submit.prevent="addRegions">
          <fieldset class="d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <label for="regionName" class="ms-2">რეგიონის სახელი(ქართულად)</label>
            <input v-model="regionDataVModels.region" pattern="[\u10A0-\u10FF\d !@#$^&\(\)\/*.+,_:?\-\\]+" type="text" autocomplete="off" name="regionName" id="regionName" required placeholder="რეგიონის სახელი(ქართულად)" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="d-flex flex-column align-items-end gap-1 light-gray-color light-text">
            <label for="regionengName" class="ms-2">(ინგლისურად)რეგიონის სახელი</label>
            <input v-model="regionDataVModels.regioneng" pattern="[A-Za-z\d !@#$^&\(\)\/*.+,_:?\-\\]+" type="text" autocomplete="off" name="regionengName" id="regionengName" required placeholder="(ინგლისურად)რეგიონის სახელი" class="blue-part-input large-text">
          </fieldset>
          <fieldset class="multiselects-wrapepr d-flex flex-column align-items-start gap-1 light-gray-color light-text">
            <p class="ms-2">აირჩიეთ შემდეგი ველები</p>
            <linearSearchingMultiSearch :multiselectArray="multiselectArray" textSearchSendName="textSearch" dateInputSendName="dateSearch"
                :allowFiltersTitle="false" :allowExportButton="false" :allowTextSearch="false" :allowDateInput="false" @finalResult="getFinalResult"/>
          </fieldset>
          <div class="button-wrapper d-flex justify-content-center w-100">
            <secondaryButton :disabled="isSending" buttonWidth="max-content" buttonType="submit" class="large-text mt-4">
                <template v-slot:content>
                    დამატება
                </template>
            </secondaryButton>
          </div>
        </form>
        
        <div class="w-100">
            <polygonMapComponent @updatePolygon="updatePolygon" maxHeight="700px"/>
        </div>
      </div>
    </div>
</template>
<script>
import secondaryButton from "@/components/secondaryButton.vue"
import primaryButtonComponent from "@/components/primaryButtonComponent.vue";
import polygonMapComponent from "@/components/polygonMapComponent.vue";
import Multiselect from '@vueform/multiselect';
import linearSearchingMultiSearch from "@/components/linearSearchingMultiSearch.vue";
export default {
  data(){
    return {
      regionDataVModels: {
        region: "",
        regioneng: "",
        cityID: null,
        polygons: [],
      },
      polygon: null,
      multiselectArray: [
      {
          placeholder: "მუნიციპალიტეტი",
          getterEndpoint: "getMunicipalities",
          options: [],
          Vmodel: null,
          sendName: null,
          mode: "single",
          isDisabled: false,
          dependancyArray: [],
          previousMultiselectId: null,
          valueName: "municipalityID",
          georgianLabel: "municipality",
          englishLabel: "municipalityeng",
          locale: "ge",
        },
        {
          placeholder: "ქალაქი",
          getterEndpoint: "getCities",
          options: [],
          Vmodel: null,
          sendName: "cityID",
          mode: "single",
          isDisabled: true,
          dependancyArray: [],
          previousMultiselectId: null,
          valueName: "cityID",
          georgianLabel: "city",
          englishLabel: "cityeng",
          locale: "ge",
        },
      ],
      isSending: false,
    }
  },
  components: {
    secondaryButton,
    primaryButtonComponent,
    polygonMapComponent,
    Multiselect,
    linearSearchingMultiSearch,
  },
  mounted(){
    // this.getCities();
  },
  methods: {
    getFinalResult(finalResultObj){
      this.regionDataVModels[finalResultObj.sendName] = finalResultObj.value;
    },
    updatePolygon(newPolygon){
        if(newPolygon == null){
            this.regionDataVModels.polygons = [];
        }
        this.polygon = newPolygon;
    },
    addRegions(){
        let isregionValid = this.$helper.checkString(this.regionDataVModels.region);
        let isEngRegionValid = this.$helper.checkEngString(this.regionDataVModels.regioneng);
        let isCityIdValid = this.$helper.checkNumber(this.regionDataVModels.cityID);
        this.regionDataVModels.polygons = [];
        let path = [];
        if(this.polygon != null){
            path = this.polygon.getPath();
            path.forEach((latLng, index) => {
                this.regionDataVModels.polygons.push({
                    lat: latLng.lat(),
                    lng: latLng.lng(),
                });
            });

        }
        

        if(isregionValid && isEngRegionValid && this.regionDataVModels.polygons.length > 0 && isCityIdValid){
          this.isSending = true;
            
            this.$store.dispatch("addRegions", this.regionDataVModels).then((response) => {
            if(response.status == 201){
                this.$helper.showSwal("რეგიონი წარმატებით დაემატა", "success", "");
                setTimeout(() => {this.$router.go()}, 1500);
            }
            }).catch((error) => {
                if(error?.response?.status == 422){
                    this.$helper.showSwal("მოხდა შეცდომა", "error", "");
                    setTimeout(() => {this.$router.go()}, 1500);
                }
            }).finally(() => {
              this.isSending = false;
            })
        }
    }
  }
}
</script>
<style scoped>
input[type="checkbox"]{
    width: 30px;
    height: 30px;
    cursor: pointer;
}
.home-container{
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, min-content);
  row-gap: 1.5em;
}
.add-form{
  background-color: var(--secondary-background-color);
  width: 60%;
}
.modal-form-grid-wrapper{
  /* width: 100%; */
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 1em;
  row-gap: 2em;
}
.modal-form-grid-wrapper .blue-part-input{
  padding-block: 15px;
  max-width: 400px;
}
.button-wrapper, .multiselects-wrapepr{
  grid-column: 1/3;
}
textarea.blue-part-input{
  width: 100%;
  resize: none;
}
.multiselect{
    --ms-placeholder-color: var(--light-blue);
    --ms-tag-bg: var(--light-blue);
    --ms-option-bg-selected: var(--light-blue);
    --ms-option-bg-selected-pointed: var(--light-blue);
    flex: 1;
    max-width: 235px;
    margin: 0;
}
#map{
    height: 500px;
    width: 100%;
}

@media screen and (max-width: 1800px) {
  .add-form{
    width: 70%;
  }
  .modal-form-grid-wrapper{
    column-gap: 2em;
    row-gap: 3em;
  }
}

@media screen and (max-width: 1560px) {
  .modal-form-grid-wrapper{
    column-gap: 2em;
    row-gap: 2em;
  }
  .modal-form-grid-wrapper .blue-part-input{
    padding: 10px;
  }
}
@media screen and (max-width: 1200px) {
  .add-form{
    width: 90%;
  }
}
</style>
